import React from 'react';

import Skeleton from '@shared/v2/components/Skeleton';

import Heading from '@/components/Heading';

export type NameProps = {
  name: string;
};

const Name = ({ name }: NameProps) => (
  <Skeleton height="1.5rem" width="200px">
    <Heading.h1 data-testid="ROOM_NAME" fontSize={['base', null, 'md']}>
      {name}
    </Heading.h1>
  </Skeleton>
);

export default Name;
